import { upperCase } from 'lodash';

import {
  HealthMemberCombo,
  IObjectKeys,
  ButtonSwitcherOptions,
  TermInsuranceProduct,
  MAX_INSURANCE_PRODUCTS,
  HEALTH_PRODUCT_PLAN_TYPES,
  BALIC_INSURANCE_PRODUCTS,
  Country,
  HDFCLIFE_INSURANCE_PRODUCTS,
  ICICIPRU_INSURANCE_PRODUCTS,
  ADITYA_BIRLA_INSURANCE_PRODUCTS_SLUGS
} from '@common/types';
import { SwitcherQuestionProps } from '@elements';
import { ComboboxItem } from '@ui';

// Contact Information for leads
export const DITTO_CUSTOMER_CONTACT_NUMBER = '080-48816818';
export const DITTO_COMPLAINTS_EMAIL = 'complaints@joinditto.in';
export const DITTO_SUPPORT_EMAIL = 'help@joinditto.in';

export const MALE = 'Male';
export const FEMALE = 'Female';
export const OTHERS = 'Transgender';

export const GENDER_OPTIONS: SwitcherQuestionProps['options'] = [
  {
    label: MALE,
    value: MALE
  },
  {
    label: FEMALE,
    value: FEMALE
  }
];

export const GENDER_OPTIONS_WITH_OTHERS = [
  ...GENDER_OPTIONS,
  {
    label: 'Others',
    value: OTHERS
  }
];

export const BOOLEAN_OPTIONS: [ButtonSwitcherOptions, ButtonSwitcherOptions] = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

export const STATES = [
  { value: 'ANDAMAN AND NICOBAR', label: 'Andaman and Nicobar Islands' },
  { value: 'ANDHRA PRADESH', label: 'Andhra Pradesh' },
  { value: 'ARUNACHAL PRADESH', label: 'Arunachal Pradesh' },
  { value: 'ASSAM', label: 'Assam' },
  { value: 'BIHAR', label: 'Bihar' },
  { value: 'CHANDIGARH', label: 'Chandigarh' },
  { value: 'CHHATTISGARH', label: 'Chhattisgarh' },
  { value: 'DADRA AND NAGAR', label: 'Dadra and Nagar Haveli' },
  { value: 'DAMAN AND DIU', label: 'Daman and Diu' },
  { value: 'DELHI', label: 'Delhi' },
  { value: 'GOA', label: 'Goa' },
  { value: 'GUJARAT', label: 'Gujarat' },
  { value: 'HARYANA', label: 'Haryana' },
  { value: 'HIMACHAL PRADESH', label: 'Himachal Pradesh' },
  { value: 'JAMMU AND KASHMIR', label: 'Jammu and Kashmir' },
  { value: 'JHARKHAND', label: 'Jharkhand' },
  { value: 'KARNATAKA', label: 'Karnataka' },
  { value: 'KERALA', label: 'Kerala' },
  { value: 'LAKSHADWEEP', label: 'Lakshadweep' },
  { value: 'MADHYA PRADESH', label: 'Madhya Pradesh' },
  { value: 'MAHARASHTRA', label: 'Maharashtra' },
  { value: 'MANIPUR', label: 'Manipur' },
  { value: 'MEGHALAYA', label: 'Meghalaya' },
  { value: 'MIZORAM', label: 'Mizoram' },
  { value: 'NAGALAND', label: 'Nagaland' },
  { value: 'ORISSA', label: 'Odisha' },
  { value: 'PONDICHERRY', label: 'Puducherry' },
  { value: 'PUNJAB', label: 'Punjab' },
  { value: 'RAJASTHAN', label: 'Rajasthan' },
  { value: 'SIKKIM', label: 'Sikkim' },
  { value: 'TAMIL NADU', label: 'Tamil Nadu' },
  { value: 'TELANGANA', label: 'Telangana' },
  { value: 'TRIPURA', label: 'Tripura' },
  { value: 'UTTARAKHAND', label: 'Uttarakhand' },
  { value: 'UTTAR PRADESH', label: 'Uttar Pradesh' },
  { value: 'WEST BENGAL', label: 'West Bengal' }
];

export const STATE_PINCODE_MAPPING: IObjectKeys = {
  11: 'DELHI',
  12: 'HARYANA',
  13: 'HARYANA',
  14: 'PUNJAB',
  15: 'PUNJAB',
  16: 'PUNJAB',
  160: 'CHANDIGARH',
  17: 'HIMACHAL PRADESH',
  18: 'JAMMU AND KASHMIR',
  19: 'JAMMU AND KASHMIR',
  20: 'UTTAR PRADESH',
  21: 'UTTAR PRADESH',
  22: 'UTTAR PRADESH',
  23: 'UTTAR PRADESH',
  24: 'UTTAR PRADESH',
  25: 'UTTAR PRADESH',
  26: 'UTTAR PRADESH',
  27: 'UTTAR PRADESH',
  28: 'UTTAR PRADESH',
  30: 'RAJASTHAN',
  31: 'RAJASTHAN',
  32: 'RAJASTHAN',
  33: 'RAJASTHAN',
  34: 'RAJASTHAN',
  36: 'GUJARAT',
  37: 'GUJARAT',
  38: 'GUJARAT',
  39: 'GUJARAT',
  40: 'MAHARASHTRA',
  41: 'MAHARASHTRA',
  42: 'MAHARASHTRA',
  43: 'MAHARASHTRA',
  44: 'MAHARASHTRA',
  45: 'MADHYA PRADESH',
  46: 'MADHYA PRADESH',
  47: 'MADHYA PRADESH',
  48: 'MADHYA PRADESH',
  49: 'CHHATTISGARH',
  50: 'TELANGANA',
  51: 'ANDHRA PRADESH',
  52: 'ANDHRA PRADESH',
  53: 'ANDHRA PRADESH',
  56: 'KARNATAKA',
  57: 'KARNATAKA',
  58: 'KARNATAKA',
  59: 'KARNATAKA',
  60: 'TAMIL NADU',
  61: 'TAMIL NADU',
  62: 'TAMIL NADU',
  63: 'TAMIL NADU',
  64: 'TAMIL NADU',
  67: 'KERALA',
  68: 'KERALA',
  69: 'KERALA',
  70: 'WEST BENGAL',
  71: 'WEST BENGAL',
  72: 'WEST BENGAL',
  73: 'WEST BENGAL',
  74: 'WEST BENGAL',
  744: 'ANDAMAN AND NICOBAR ISLANDS',
  75: 'ORISSA',
  76: 'ORISSA',
  77: 'ORISSA',
  78: 'ASSAM',
  790: 'ARUNACHAL PRADESH',
  791: 'ARUNACHAL PRADESH',
  792: 'ARUNACHAL PRADESH',
  793: 'MEGHALAYA',
  794: 'MEGHALAYA',
  795: 'MANIPUR',
  796: 'MIZORAM',
  797: 'NAGALAND',
  798: 'NAGALAND',
  799: 'TRIPURA',
  80: 'BIHAR',
  81: 'BIHAR',
  813: 'BIHAR',
  813208: 'JHARKHAND',
  814: 'JHARKHAND',
  814131: 'BIHAR',
  815: 'JHARKHAND',
  816: 'JHARKHAND',
  82: 'BIHAR',
  821: 'BIHAR',
  822: 'JHARKHAND',
  823: 'BIHAR',
  824: 'BIHAR',
  825: 'JHARKHAND',
  826: 'JHARKHAND',
  827: 'JHARKHAND',
  828: 'JHARKHAND',
  829: 'JHARKHAND',
  83: 'JHARKHAND',
  84: 'BIHAR',
  85: 'BIHAR'
};

export const TERM_QUOTE_STEPS = {
  COVER_AND_DURATION: 0,
  PLANS_AVAILABLE: 1,
  PLAN_DETAILS: 2,
  PAYMENT_TERM_OPTIONS: 3,
  ADDONS: 4,
  SUMMARY: 5,
  ORDER_DETAILS: 6
};

export const TERM_FAST_QUOTE_STEPS = {
  COVER_AND_DURATION: 0,
  PAYMENT_TERM_OPTIONS: 1,
  ADDONS: 2,
  SUMMARY: 3,
  ORDER_DETAILS: 4
};

export const HEALTH_QUOTE_STEPS = {
  COVER: 0,
  // RECOMMENDED_PLAN: 1,
  PLANS_AVAILABLE: 1,
  PLAN_DETAILS: 2,
  FINALIZE: 3,
  ORDER_DETAILS: 4
};

export const TERM_INSURANCE_PROVIDERS = {
  ICICIPRU: 'ICICIPRU',
  MAXLIFE: 'MAXLIFE',
  HDFCLIFE: 'HDFCLIFE',
  BALIC: 'BALIC'
};

export const TERM_INSURANCE_PROVIDER_NAMES: IObjectKeys = {
  ICICIPRU: 'ICICI Prudential',
  MAXLIFE: 'Axis Max Life',
  HDFCLIFE: 'HDFC Life',
  BALIC: 'Bajaj Life'
};

export const TERM_INSURANCE_PRODUCTS: {
  [key in TermInsuranceProduct]: TermInsuranceProduct;
} = {
  I_PROTECT_SMART_PLUS: 'I_PROTECT_SMART_PLUS',
  I_PROTECT_SMART: 'I_PROTECT_SMART',
  SMART_SECURE_PLUS: 'SMART_SECURE_PLUS',
  CLICK_2_PROTECT_LIFE: 'CLICK_2_PROTECT_LIFE',
  CLICK_2_PROTECT_SUPER: 'CLICK_2_PROTECT_SUPER',
  CLICK_2_PROTECT_SUPREME: 'CLICK_2_PROTECT_SUPREME',
  CLICK_2_PROTECT_SUPREME_PLUS: 'CLICK_2_PROTECT_SUPREME_PLUS',
  SMART_TOTAL_ELITE: 'SMART_TOTAL_ELITE',
  SMART_TERM_PLAN_PLUS: 'SMART_TERM_PLAN_PLUS',
  E_TOUCH: 'E_TOUCH'
};

export const USER_COVER_TILL_VALUES = (
  start: number,
  min?: number,
  max?: number
) => {
  const ages = [];
  const minAge = min ? min : start + 10;
  const maxAge = max ? max : 85;
  for (let i = minAge; i <= maxAge; i++) {
    ages.push(i);
  }
  return ages;
};

// Add on names
export const LIFE_STAGE_BENEFIT = 'Life stage benefit';
export const HDFC_LIFE_STAGE_ADD_ON_NAME = 'Life stage';
export const TERMINAL_ILLNESS = 'Terminal illness';
export const WAIVER_OF_PREMIUM = 'Waiver of premium';
export const INCOME_BENEFIT = 'Income Benefit Rider';
export const ACCIDENTAL_DEATH = 'Accidental cover';
export const ACCIDENTAL_DEATH_AND_DISMEMBERMENT =
  'Accidental death and dismemberment rider';
export const CRITICAL_ILLNESS = 'Critical illness';
export const EARLY_EXIT_OPTION = 'Early exit option';
export const COVER_CONTINUANCE_BENEFIT = 'Cover Continuance Benefit';
export const INSTA_PAYMENT = 'Insta payment';
export const SMART_EXIT_BENEFIT_NAME = 'Smart Exit Benefit';
export const ADDITIONAL_SMART_EXIT_BENEFIT_NAME = 'Additional Smart Exit Benefit';
export const IMMEDIATE_PAYOUT_ON_INTIMATION = 'Immediate Payout on Claim Intimation';

// Note: DO NOT CHANGE THESE SLUGS
// Leads will use old links to continue their applications,
// Hence - changing slugs also needs to add backward compatibility support.
export const IPRU_PROPOSAL_SLUG = 'icicipru';
export const TERM_PRODUCTS_SLUGS: IObjectKeys = {
  I_PROTECT_SMART_PLUS: 'iciciplus',
  I_PROTECT_SMART: 'icici',
  SMART_SECURE_PLUS: 'maxlife',
  CLICK_2_PROTECT_SUPER: 'hdfcc2ps',
  CLICK_2_PROTECT_SUPREME: 'hdfcc2psn',
  CLICK_2_PROTECT_SUPREME_PLUS: 'hdfcc2psp',
  CLICK_2_PROTECT_LIFE: 'hdfc',
  SMART_TOTAL_ELITE: 'maxlifestep',
  E_TOUCH: 'e-touch',
  SMART_TERM_PLAN_PLUS: 'maxlifestpp'
};

export const SELF = 'Self';
export const FATHER = 'Father';
export const MOTHER = 'Mother';
export const SPOUSE = 'Spouse';
export const KIDS = 'Kids';
export const SON = 'Son';
export const DAUGHTER = 'Daughter';
export const FATHER_IN_LAW = 'Father-in-law';
export const MOTHER_IN_LAW = 'Mother-in-law';

export const MEMBER_RELATIONS = [SELF, FATHER, MOTHER, SPOUSE, KIDS, SON, DAUGHTER];

export const HEALTH_MEMBER_COMBO_SELF = 'You';
export const HEALTH_MEMBER_COMBO_PARENTS = 'Your Parents';
export const HEALTH_MEMBER_COMBO_FAMILY = 'Your Family';

export const HEALTH_MEMBER_COMBOS: HealthMemberCombo[] = [
  {
    name: HEALTH_MEMBER_COMBO_SELF,
    description: 'For self',
    relations: [SELF]
  },
  {
    name: HEALTH_MEMBER_COMBO_PARENTS,
    description: 'Your mother and father',
    relations: [FATHER, MOTHER]
  },
  {
    name: HEALTH_MEMBER_COMBO_FAMILY,
    description: 'You, your spouse, and your kids',
    relations: [SELF, SPOUSE]
  }
];

export const HEALTH_INSURANCE_PROVIDERS = {
  NIVABUPA: 'NIVABUPA',
  HDFCERGO: 'HDFCERGO',
  CARE: 'CARE',
  ADITYABIRLA: 'ADITYABIRLA'
};

export const HEALTH_INSURANCE_PROVIDER_NAMES: IObjectKeys = {
  NIVABUPA: 'Niva Bupa',
  HDFCERGO: 'HDFC Ergo',
  CARE: 'Care',
  ADITYABIRLA: 'Aditya Birla'
};

export const HEALTH_INSURANCE_PROVIDER_CUSTOMER_PORTALS: IObjectKeys = {
  NIVABUPA: 'https://rules.nivabupa.com/customer-service/',
  HDFCERGO: 'https://selfhelp.hdfcergo.com/SelfHelp/Authentication/KnowYourPolicy',
  CARE: 'https://selfcare.careinsurance.com/',
  ADITYABIRLA: 'https://www.adityabirlacapital.com/healthinsurance/login'
};

export const HEALTH_INSURER_SLUGS = {
  NIVABUPA: 'nivabupa',
  HDFCERGO: 'hdfcergo',
  CARE: 'care'
};

// NOTE: Kindly add in insurer wise products as well.
export const HEALTH_INSURANCE_PRODUCTS = {
  COMPANION: 'COMPANION',
  REASSURE: 'REASSURE',
  REASSURE_3: 'REASSURE_3',
  OPTIMA_RESTORE: 'OPTIMA_RESTORE',
  OPTIMA_SECURE: 'OPTIMA_SECURE',
  OPTIMA_SECURE_PLUS: 'OPTIMA_SECURE_PLUS',
  OPTIMA_SUPER_SECURE: 'OPTIMA_SUPER_SECURE',
  ENERGY_SILVER: 'ENERGY_SILVER',
  MEDISURETOPUP: 'MEDISURETOPUP',
  RECHARGE: 'RECHARGE',
  CARE_WITH_NCB: 'CARE_WITH_NCB',
  CARE_ADVANTAGE: 'CARE_ADVANTAGE',
  CARE_FREEDOM: 'CARE_FREEDOM',
  CARE_PLUS_YOUTH: 'CARE_PLUS_YOUTH',
  CARE_PLUS_COMPLETE: 'CARE_PLUS_COMPLETE',
  CARE_SUPREME: 'CARE_SUPREME',
  CARE_ULTIMATE: 'CARE_ULTIMATE',
  CARE_HEART: 'CARE_HEART',
  ACTIV_ONE: 'ACTIV_ONE',
  ACTIV_FIT: 'ACTIV_FIT',
  ACTIV_ONE_VYTL: 'ACTIV_ONE_VYTL'
};

export const HEALTH_DISCONTINUED_PRODUCTS = [
  HEALTH_INSURANCE_PRODUCTS.CARE_WITH_NCB
];

export const UNDERSTAND_YOUR_HEALTH_POLICY_DMA_BASE_LINK =
  'https://joinditto.in/health-insurance';
// URL paths mapping
export const UNDERSTAND_YOUR_HEALTH_POLICY_DMA_PATHS = {
  // Niva Bupa
  [HEALTH_INSURANCE_PRODUCTS.REASSURE]: {
    [HEALTH_PRODUCT_PLAN_TYPES.BRONZE_PLUS]: '/max-bupa/reassure-2-bronze',
    [HEALTH_PRODUCT_PLAN_TYPES.PLATINUM_PLUS]: '/max-bupa/reassure-2-platinum',
    [HEALTH_PRODUCT_PLAN_TYPES.TITANIUM_PLUS]: '/max-bupa/reassure-2-titanium'
  },
  [HEALTH_INSURANCE_PRODUCTS.COMPANION]: '/max-bupa/health-companion',
  [HEALTH_INSURANCE_PRODUCTS.RECHARGE]: '/max-bupa/health-recharge-super-top-up',

  // HDFC Ergo
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_RESTORE]: '/hdfc-ergo/optima-restore',
  [HEALTH_INSURANCE_PRODUCTS.MEDISURETOPUP]:
    '/hdfc-ergo/myhealth-medisure-super-top-up',
  [HEALTH_INSURANCE_PRODUCTS.ENERGY_SILVER]: '/hdfc-ergo/energy-silver',
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE]: '/hdfc-ergo/optima-secure',
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE_PLUS]: '/hdfc-ergo/optima-secure-plus',
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SUPER_SECURE]: '/hdfc-ergo/optima-super-secure',

  // Care
  [HEALTH_INSURANCE_PRODUCTS.CARE_ADVANTAGE]: '/care-insurance/care-advantage',
  [HEALTH_INSURANCE_PRODUCTS.CARE_FREEDOM]: '/care-insurance/care-freedom-plan',
  [HEALTH_INSURANCE_PRODUCTS.CARE_PLUS_YOUTH]: '/care-insurance/care-plus-youth',
  [HEALTH_INSURANCE_PRODUCTS.CARE_PLUS_COMPLETE]:
    '/care-insurance/care-plus-complete',
  [HEALTH_INSURANCE_PRODUCTS.CARE_SUPREME]: '/care-insurance/care-supreme',
  [HEALTH_INSURANCE_PRODUCTS.CARE_ULTIMATE]: '/care-insurance/care-ultimate',
  [HEALTH_INSURANCE_PRODUCTS.CARE_HEART]: '/care-insurance/care-heart',

  // Aditya Birla
  [HEALTH_INSURANCE_PRODUCTS.ACTIV_ONE]: {
    [HEALTH_PRODUCT_PLAN_TYPES.NXT]: '/aditya-birla/activ-one-nxt',
    [HEALTH_PRODUCT_PLAN_TYPES.MAX]: '/aditya-birla/activ-one-max'
    //[HEALTH_PRODUCT_PLAN_TYPES.VYTL]: '/aditya-birla/activ-one-vytl'
  },
  [HEALTH_INSURANCE_PRODUCTS.ACTIV_FIT]: {
    [HEALTH_PRODUCT_PLAN_TYPES.PLUS]: '/aditya-birla/aditya-birla-activ-fit-plus',
    [HEALTH_PRODUCT_PLAN_TYPES.PREFERRED]: '/aditya-birla/activ-fit-preferred'
  }
};

export const HEALTH_INSURANCE_PRODUCTS_QUOTE_SLUGS: IObjectKeys = {
  COMPANION: 'companion',
  REASSURE_3: 'reassure-3',
  REASSURE: 'reassure',
  OPTIMA_RESTORE: 'optima-restore',
  OPTIMA_SECURE: 'optima-secure',
  OPTIMA_SECURE_PLUS: 'optima-secure-plus',
  OPTIMA_SUPER_SECURE: 'optima-super-secure',
  ENERGY_SILVER: 'energy-silver',
  MEDISURETOPUP: 'medisure',
  RECHARGE: 'recharge',
  // CARE_ADVANTAGE: 'care-advantage',
  CARE_FREEDOM: 'care-freedom',
  // CARE_PLUS_YOUTH: 'care-plus-youth',
  // CARE_PLUS_COMPLETE: 'care-plus-complete',
  CARE_SUPREME: 'care-supreme',
  CARE_ULTIMATE: 'care-ultimate',
  CARE_HEART: 'care-heart',
  // CARE_WITH_NCB: 'care',
  ACTIV_ONE: 'activ-one',
  ACTIV_FIT: 'activ-fit',
  ACTIV_ONE_VYTL: 'activ-one-vytl'
};

export const HEALTH_INSURANCE_PRODUCT_NAMES: IObjectKeys = {
  OPTIMA_RESTORE: 'Optima Restore',
  OPTIMA_SECURE: 'Optima Secure',
  OPTIMA_SECURE_PLUS: 'Optima Secure +',
  OPTIMA_SUPER_SECURE: 'Optima Super Secure',
  ENERGY_SILVER: 'Energy Silver',
  MEDISURETOPUP: 'myHealth Medisure Super Top-Up',
  CARE_FREEDOM: 'Care Freedom',
  CARE_SUPREME: 'Care Supreme',
  CARE_ULTIMATE: 'Ultimate Care',
  CARE_HEART: 'Care Heart',
  // https://linear.app/ditto-in/issue/DWA-312/care-complete-showing-same-premiums-for-5l-7l-and-10l
  // CARE_PLUS_YOUTH: 'Care Plus - Youth health plan',
  // CARE_PLUS_COMPLETE: 'Care Plus - The complete health plan',
  // CARE_WITH_NCB: 'Care with NCB Super',
  // CARE_ADVANTAGE: 'Care Advantage',
  ACTIV_ONE: 'Activ One',
  ACTIV_FIT: 'Activ Fit',
  ACTIV_ONE_VYTL: 'activ-one-vytl',
  REASSURE: 'ReAssure',
  REASSURE_3: 'ReAssure 3.0',
  COMPANION: 'Companion',
  RECHARGE: 'Health Recharge'
};

export const CARE_FREEDOM_MIN_AGE_FOR_ABOVE_5L = 46;
export const CARE_ADV_NCB_MANDATE_AGE = 76;
export const CARE_ADV_NCB_PINCHECK_AGE = 45;
export const CARE_PLUS_COMPLETE_MIN_AGE = 36;

// Health addons
export const OPD = 'opd_care';
export const CHRONIC_CARE = 'cc';
// ABCD Chronic Care
export const ABCD = 'abcd';
// Hospital Cash Benefit
export const HCB = 'hcb';
// Parenthood
export const PARENT_HOOD = 'pth';
// Reduction in PED
export const RPED = 'rped';
// Specified disease waiting period modification
export const SPED_MOD = 'sped_mod';

export const REFERRER_PARAM_NAME = 'ref';
export const REFERRER_COOKIE_NAME = 'ref';

export const ANNUAL_INCOME_PARAM_NAME = 'annInc';
export const GENDER_PARAM_NAME = 'gender';
export const DOB_PARAM_NAME = 'dob';
export const EXPENSES_PARAM_NAME = 'mExp';
export const PINCODE_PARAM_NAME = 'pincode';

export const MEMBER_SELECTION_SUPPORTED_ADDONS = {
  [HEALTH_INSURANCE_PRODUCTS.ACTIV_FIT]: [OPD],
  [HEALTH_INSURANCE_PRODUCTS.ACTIV_ONE]: [CHRONIC_CARE, OPD],
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE]: [ABCD],
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SECURE_PLUS]: [ABCD],
  [HEALTH_INSURANCE_PRODUCTS.OPTIMA_SUPER_SECURE]: [ABCD]
};

const WHATSAPP_PHONE_NUMBER = '+918867919680';
export const getWhatsappUrl = (text?: string) => {
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE_NUMBER}&text=${
    text ? text : 'Hi'
  }`;
};

export const getInsurerFromProduct = (product: any): string => {
  switch (true) {
    case product === TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART:
    case product === TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART_PLUS:
      return TERM_INSURANCE_PROVIDERS.ICICIPRU;
    case product === TERM_INSURANCE_PRODUCTS.E_TOUCH:
      return TERM_INSURANCE_PROVIDERS.BALIC;
    case [
      TERM_INSURANCE_PRODUCTS.SMART_SECURE_PLUS,
      TERM_INSURANCE_PRODUCTS.SMART_TOTAL_ELITE,
      TERM_INSURANCE_PRODUCTS.SMART_TERM_PLAN_PLUS
    ].includes(product):
      return TERM_INSURANCE_PROVIDERS.MAXLIFE;
    case [
      TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_LIFE,
      TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPER,
      TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPREME,
      TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPREME_PLUS
    ].includes(product):
      return TERM_INSURANCE_PROVIDERS.HDFCLIFE;
    default:
      return '';
  }
};

// Mapping product route slugs to products
export const SLUG_PRODUCT_MAP = {
  [MAX_INSURANCE_PRODUCTS.smart_total_elite]:
    TERM_INSURANCE_PRODUCTS.SMART_TOTAL_ELITE,
  [MAX_INSURANCE_PRODUCTS.smart_term_plan_plus]:
    TERM_INSURANCE_PRODUCTS.SMART_TERM_PLAN_PLUS,
  [ICICIPRU_INSURANCE_PRODUCTS.i_protect_smart]:
    TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART,
  [ICICIPRU_INSURANCE_PRODUCTS.i_protect_smart_plus]:
    TERM_INSURANCE_PRODUCTS.I_PROTECT_SMART_PLUS,
  [HDFCLIFE_INSURANCE_PRODUCTS.click_2_protect_life]:
    TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_LIFE,
  [HDFCLIFE_INSURANCE_PRODUCTS.click_2_protect_super]:
    TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPER,
  [HDFCLIFE_INSURANCE_PRODUCTS.click_2_protect_supreme]:
    TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPREME,
  [HDFCLIFE_INSURANCE_PRODUCTS.click_2_protect_supreme_plus]:
    TERM_INSURANCE_PRODUCTS.CLICK_2_PROTECT_SUPREME_PLUS,
  [BALIC_INSURANCE_PRODUCTS.e_touch]: TERM_INSURANCE_PRODUCTS.E_TOUCH,
  [ADITYA_BIRLA_INSURANCE_PRODUCTS_SLUGS.activ_one]:
    HEALTH_INSURANCE_PRODUCTS.ACTIV_ONE,
  [ADITYA_BIRLA_INSURANCE_PRODUCTS_SLUGS.activ_fit]:
    HEALTH_INSURANCE_PRODUCTS.ACTIV_FIT,
  [ADITYA_BIRLA_INSURANCE_PRODUCTS_SLUGS.activ_one_vytl]:
    HEALTH_INSURANCE_PRODUCTS.ACTIV_ONE_VYTL
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const MONTH_FORMAT = 'MM/YYYY';
export const DATE_DISPLAY_FORMAT = 'DD-MM-YYYY';

export const MAXLIFE_TERM_DOC_SUPPORTED_FILE_EXTS = ['pdf', 'jpeg', 'jpg'];
export const TERM_DOC_SUPPORTED_FILE_EXTS = [
  ...MAXLIFE_TERM_DOC_SUPPORTED_FILE_EXTS,
  'png'
];
export const DEFAULT_DOC_MAX_FILE_SIZE = 10_000_000;
export const MAX_AND_HDFCLIFE_DOC_MAX_FILE_SIZE = 3_000_000;
export const IPRU_DOC_MAX_FILE_SIZE = 5_000_000;
export const ADITYA_BIRLA_DOC_MAX_FILE_SIZE = 5_000_000;

export const DOC_NAME: IObjectKeys = {
  'Aadhaar Card': 'AADHAAR',
  Aadhaar: 'AADHAAR',
  'Voter ID': 'VOTER ID',
  Passport: 'PASSPORT',
  'Defence ID Card': 'DEFENCE ID',
  'Driving License': 'LICENCE',
  'Government Registered Document or ID Proof': 'GOVT ID PROOF',
  'Government Employee ID': 'GOVT EMP ID',
  'Employers Certificate': 'EMPLOYERS CERTIFICATE',
  'Income Tax Return': 'ITR'
};

export const getDocName = (docName: string) => {
  if (!docName) return 'DOC';

  return DOC_NAME[docName] ? DOC_NAME[docName] : upperCase(docName);
};

// A foot contains 12 inches.
export const ONE_FEET_IN_INCHES = 12;
// 1 inch = 2.54 centimeters.
export const ONE_INCH_IN_CM = 2.54;
// 1 foot = 12 * 2.54 centimeters (or 30.48 centimeters).
export const ONE_FEET_IN_CM = ONE_FEET_IN_INCHES * ONE_INCH_IN_CM;

export const MONTH_OPTIONS: ComboboxItem[] = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' }
];

export const COUNTRY_INDIA: Country = {
  name: 'India',
  calling_code: '91',
  code: 'IN'
};

export const EMI_FREQUENCY_MAPPING: any = {
  Monthly: 'Month',
  Quarterly: '3 Months',
  HalfYearly: '6 Months',
  Yearly: '1 Year'
};

export const ifscCodeErrorMsg =
  'Invalid format. Code must be 11 characters: 4 uppercase letters, followed by the digit 0, followed by 6 uppercase letters or digits.';

export const FE_DATE_FORMAT = 'DD-MM-YYYY';
export const BANK_ACCOUNT_TYPES: ComboboxItem[] = [
  {
    label: 'Savings',
    value: 'Savings'
  },
  {
    label: 'Current',
    value: 'Current'
  }
];
export const getTermProductDetails = (product: TermInsuranceProduct) => {
  const TERM_INSURANCE_PRODUCT_DETAILS: any = {
    I_PROTECT_SMART_PLUS: {
      provider: TERM_INSURANCE_PROVIDERS.ICICIPRU,
      providerName: 'ICICI Prudential',
      policyName: 'ICICI iProtect Smart Plus',
      policyBaseName: 'iProtect Smart Plus'
    },
    I_PROTECT_SMART: {
      provider: TERM_INSURANCE_PROVIDERS.ICICIPRU,
      providerName: 'ICICI Prudential',
      policyName: 'ICICI iProtect Smart',
      policyBaseName: 'iProtect Smart'
    },
    SMART_SECURE_PLUS: {
      provider: TERM_INSURANCE_PROVIDERS.MAXLIFE,
      providerName: 'Axis Max Life',
      policyName: 'Axis Max Life Smart Secure Plus Plan',
      policyBaseName: 'Smart Secure Plus Plan'
    },
    CLICK_2_PROTECT_LIFE: {
      provider: TERM_INSURANCE_PROVIDERS.HDFCLIFE,
      providerName: 'HDFC Life',
      policyName: 'HDFC Life Click 2 Protect Life',
      policyBaseName: 'Click 2 Protect Life'
    },
    CLICK_2_PROTECT_SUPER: {
      provider: TERM_INSURANCE_PROVIDERS.HDFCLIFE,
      providerName: 'HDFC Life',
      policyName: 'HDFC Life Click 2 Protect Super',
      policyBaseName: 'Click 2 Protect Super'
    },
    CLICK_2_PROTECT_SUPREME: {
      providerName: 'HDFC Life',
      policyName: 'HDFC Life Click 2 Protect Supreme',
      policyBaseName: 'Click 2 Protect Supreme'
    },
    CLICK_2_PROTECT_SUPREME_PLUS: {
      provider: TERM_INSURANCE_PROVIDERS.HDFCLIFE,
      providerName: 'HDFC Life',
      policyName: 'HDFC Life Click 2 Protect Supreme Plus',
      policyBaseName: 'Click 2 Protect Supreme Plus'
    },
    E_TOUCH: {
      provider: TERM_INSURANCE_PROVIDERS.BALIC,
      providerName: 'Bajaj Life',
      policyName: 'Bajaj Life - eTouch II',
      policyBaseName: 'E Touch II'
    },
    SMART_TOTAL_ELITE: {
      provider: TERM_INSURANCE_PROVIDERS.MAXLIFE,
      providerName: 'Axis Max Life',
      policyName: 'Axis Max Life Smart Total Elite Protection Plan',
      policyBaseName: 'Smart Total Elite Protection Plan'
    },
    SMART_TERM_PLAN_PLUS: {
      provider: TERM_INSURANCE_PROVIDERS.MAXLIFE,
      providerName: 'Axis Max Life',
      policyName: 'Axis Max Life Smart Term Plan Plus',
      policyBaseName: 'Smart Term Plan Plus'
    }
  };

  return TERM_INSURANCE_PRODUCT_DETAILS[product];
};
export const ADDRESS_PROOF_WARNING_MESSAGE =
  'Please keep your address proof handy while filling the address. Address mismatch can cause rejection of address proof. Double-check that the following match your ID proof exactly:<br/><br/>• House Number<br/>• House Name<br/>• City<br/>• Pincode';

export const MEDICAL_APPOINTMENT_WARNING_MESSAGE =
  'The selected medical appointment will be confirmed only after the medical team contacts you via call, message, or email regarding slot and center availability.';

export const SMS = 'SMS';
export const WHATSAPP = 'WhatsApp';

export const MULTI_SELECT_AUTOCOMPLETE = 'multiSelectAutocomplete';

export const DOC_ADDRESS_PROOF = 'addressproof';
export const DOC_AGE_PROOF = 'ageproof';
export const DOC_COVID_PROOF = 'covidproof';
export const DOC_INCOME_PROOF = 'incomeproof';
export const DOC_PHOTOGRAPH = 'photograph';
export const DOC_PHOTO_ID = 'photoid';

export const DOC_PROOF_ICONS: IObjectKeys = {
  'Age Proof': DOC_AGE_PROOF,
  'Address Proof': DOC_ADDRESS_PROOF,
  'Covid - 19 Declaration': DOC_COVID_PROOF,
  Photograph: DOC_PHOTOGRAPH,
  'Income Proof': DOC_INCOME_PROOF,
  'Photo ID': DOC_PHOTO_ID
};

export const getDocProofIcon = (docName: string) => {
  return DOC_PROOF_ICONS[docName]
    ? DOC_PROOF_ICONS[docName]
    : DOC_PROOF_ICONS['Photo ID'];
};
